<y42-list-view
  y42FeatureListView
  [id]="$any(state.id)"
  [name]="name"
  [searchLabel]="searchLabel"
  [searchPlaceholder]="searchPlaceholder"
  [columnDefs]="columnDefs"
  [gridOptions]="state.gridOptions"
  [frameworkComponents]="frameworkComponents"
  [messages]="state.messages"
  [canAdd]="true"
  [addPermissionAllowed]="state.addPermissionAllowed"
  y42HighlightActiveAsset
  y42RedirectToDetailOnClick
></y42-list-view>
